export default __webpack_public_path__ + "989e4fbdea55d4a29aeb345b846b904a.png";